// Empty configuration uses the current environment's linked /api backend.
// Authentication and module requests must never choose different environments.
export function resolveApiBase(configured = '') {
  return `${configured.trim().replace(/\/+$/, '')}/api`;
}

export const API_BASE = resolveApiBase(import.meta.env?.VITE_API_BASE_URL);
